import * as api from "./client.js";

/**
 * Staff BFF service — consumer-facing endpoints exposed by services/staff-bff.
 *
 * These are scoped per-user / per-session and are distinct from the
 * platform-wide admin endpoints in `platform.service.ts` (which manage
 * platform-level configuration like feature flag overrides, services list
 * etc.). This service is for "what does THIS user / session see".
 */

export type FeatureFlagEvaluation = {
  key: string;
  variantKey: string;
  value: unknown;
};

export type FeatureFlagsListResponse = {
  flags: Record<string, FeatureFlagEvaluation>;
  registrationMaintenanceMode: boolean;
  registrationMaintenanceNotice: string;
};

export const staffBffService = {
  featureFlags: {
    async list(): Promise<FeatureFlagsListResponse> {
      return api.get<FeatureFlagsListResponse>("/feature-flags");
    },
  },
};
